// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ArrowBackIos } from '@material-ui/icons';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { statuses } from '../../../../../../config/types';
import { getOrder } from '../OrderFull/store/selectors';
import * as orderDetailsActions from '../OrderFull/store/actions';
import history from '../../../../../../services/history';
import styles from './styles';
import ArrangeCollectionPage
  from '../../../../../arrange-collection/container/ArrangeCollectionPage';

const statusApplied = [7, 13, 15];
class ArrangeCollectionView extends Component {
  state = {};

  renderTop = () => {
    const { classes, order } = this.props;
    let statusId = 0;
    Object.keys(statuses).map((key) => {
      if (statuses[key] === order.OrderStatus) {
        statusId = key;
      }
      return null;
    });
    statusId = parseInt(statusId, 10);
    const background = statusApplied.includes(statusId) ? classes.paid : classes.processing;

    return (
      <div className={classNames(classes.topContainer, background)}>
        <MediaQuery minDeviceWidth={600}>
          <div
            role={'button'}
            tabIndex={0}
            onKeyPress={() => history.goBack()}
            onClick={() => history.goBack()}
            className={classes.arrowBackContainer}
          >
            <ArrowBackIos />
            <div className={classes.link}>Back</div>
          </div>
        </MediaQuery>
        <span className={classes.orderIdText}>{`ORDER ID: ${order.OrderID}`}</span>
        <div className={classes.dateTimeContainer}>
          <span className={classes.orderTime}>{order.CreatedOn}</span>
        </div>
      </div>
    );
  }

  render() {
    const { classes, order } = this.props;

    return (
      <div className={classes.mainContainer}>
        {this.renderTop()}
        <ArrangeCollectionPage orderIdFromAccountPage={order.OrderID} />
        <div className={classes.contentContainer} />
      </div>);
  }
}

const mapStateToProps = (state) => {
  return {
    order: getOrder(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestOrder: data => dispatch(orderDetailsActions.requestOrderDetails(data)),
    resetOrder: () => dispatch(orderDetailsActions.resetOrder()),
  };
};

ArrangeCollectionView.propTypes = {
  classes: PropTypes.object,
  order: PropTypes.object,
};

ArrangeCollectionView.defaultProps = {
  classes: {},
  order: {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ArrangeCollectionView));
